import {
  FETCH_ORDER_REQUESTED,
  FETCH_ORDER_SUCCEEDED,
  FETCH_ORDER_FAILED,
} from './actionTypes'

export function fetchOrderRequested(params) {
  return {
    type: FETCH_ORDER_REQUESTED,
    payload: params,
  }
}

export function fetchOrderSucceeded(order = {}) {
  return {
    type: FETCH_ORDER_SUCCEEDED,
    payload: order,
  }
}

export function fetchOrderFailed(error) {
  return {
    type: FETCH_ORDER_FAILED,
    payload: error,
    error: true,
  }
}



// WEBPACK FOOTER //
// ./src/store/order/action.js